import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  dev: true,
  local: false,
  fe: false,
  stage: false,
  authenticationUrl: 'https://dev.frontend.pluralo.com/',
  logoutUrl: 'https://dev.frontend.pluralo.com/logout',
  version: '3.0.0',
  resourceServer: 'https://dev.backend.pluralo.com/api/',
  authenticationServer: 'https://dev.backend.pluralo.com/api/',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts